import { LATEST_SEARCH_LIMIT, LATEST_SEARCH_LOCAL_STORAGE } from '../constants'

export default async (item, source = false, type = false, id = false) => {
  let items = JSON.parse(localStorage.getItem(LATEST_SEARCH_LOCAL_STORAGE))

  items = Array.isArray(items) ? items : []
  items = [
    {
      name: item, source, type, id,
    },
    ...items,
  ]

  // Make it unique.
  items = items.filter((value, i, self) => (self.findIndex(o => o.name === value.name) === i))
  items = items.slice(0, LATEST_SEARCH_LIMIT)

  localStorage.setItem(LATEST_SEARCH_LOCAL_STORAGE, JSON.stringify(items))
}
